import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl/dist';
import { adjustUTCToLocalTime } from '../../../utils/dates/dateMethods.js';

const MinnesotaFooter = (props) => {
    const {
        environment: {
            links: {
                PRIVACY_POLICY
            },
            localDates: {
                timezoneOffsetMs=0,
                dstSavingsMs=0,
                serverDateInUTC,
                timezone
            }
        }
    } = props;

    const { sDate, sTime } = adjustUTCToLocalTime(serverDateInUTC, timezoneOffsetMs, dstSavingsMs);

    return(   	
        <Fragment>
            <footer id="footer--mn" className="usa-footer gi-footer" role="contentinfo">
                <div className="grid-container gi-footer__container">
                    <div className="usa-footer__primary-section gi-footer__primary-section">
                        <div className="grid-row grid-gap">
                            <div className="usa-footer__logo gi-footer__logo grid-row mobile-lg:grid-col-12 mobile-lg:grid-gap-2">
                                <div className="mobile-lg:grid-col-auto" id="copyrights">
                                    <FormattedMessage id='footer.copyright' values={{ date: (new Date().getFullYear()) }}/>
                                </div>
                                <div className="mobile-lg:grid-col-auto gi-footer--link-margin">
                                    <a href={ PRIVACY_POLICY }><FormattedMessage id='footer.privacy_policy'/></a>
                                </div>
                                <div className="mobile-lg:grid-col-auto gi-footer--link-margin"><FormattedMessage id='footer.server_date' values={{ date: sDate }}/></div>
                                <div className="mobile-lg:grid-col-auto gi-footer--link-margin">
                                    <FormattedMessage id='footer.server_time' values={{ time: sTime }}/>
                                    <span className="mobile-lg:grid-col-auto gi-footer--link-margin">  {timezone}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </Fragment>
    );
};

export default MinnesotaFooter;
